import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';

export default function DataFaturaFaturado({ id, data, onGuardada }) {
    const original = data?.slice(0,10) || '';
    const [valor, setValor] = useState(original);
    const [estado, setEstado] = useState('');
    const alterada = useRef(false);
    const gravando = useRef(false);
    useEffect(() => { if (!alterada.current) setValor(original); }, [original]);

    async function guardar(event) {
        if (gravando.current || !alterada.current) return;
        if (event && !event.currentTarget.validity.valid) {
            setEstado('Introduza uma data válida.');
            return;
        }
        gravando.current = true;
        setEstado('A guardar…');
        try {
            const resposta = await api.patch('/gestao-financeira/faturados/'+id+'/data-fatura', { data_fatura: valor || null });
            alterada.current = false;
            onGuardada(resposta.data.data_fatura);
            setEstado('');
        } catch {
            setEstado('Não foi guardada. Volte a selecionar o campo e saia para tentar novamente.');
        } finally {
            gravando.current = false;
        }
    }
    return <div onClick={e => e.stopPropagation()}>
        <input type="date" className="gf-inline-input" aria-label={'Data de emissão da fatura do orçamento '+id}
            value={valor} disabled={estado === 'A guardar…'}
            aria-invalid={!!estado && estado !== 'A guardar…'}
            onChange={e => { setValor(e.target.value); alterada.current = true; setEstado(''); }}
            onBlur={guardar} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); } }} />
        {estado && <small role="status" style={{display:'block',maxWidth:160}}>{estado}</small>}
    </div>;
}
